import {gemStore} from 'app/gemStore';
import {EditRolloverDataState} from 'app/modules/aem/edit';
import {TriggerMsg} from 'app/modules/authorComponentAlert/types';
import {getComponentConfiguration} from 'app/utils/config';
import {getChannel} from 'app/utils/getChannel';
import {hasProp} from 'app/utils/hasProp';
import {ComponentAlertsConfig} from 'interfaces/foundation/components/componentAlertsConfig';

export function defineAuthorComponentAlert() {
    if (customElements.get('gem-author-component-alert')) {
        return;
    }

    customElements.define(
        'gem-author-component-alert',
        class extends HTMLElement {
            unsubscribe: (() => void) | undefined;
            connectedCallback() {
                const config = getComponentConfiguration(this);
                if (!hasProp<ComponentAlertsConfig>('alerts', config)) {
                    throw new Error('ComponentAlertsConfig is missing!');
                }

                let prevEditRolloverData: EditRolloverDataState | undefined;
                const triggerEventByStateChange = (editRolloverData: EditRolloverDataState = gemStore.getState().aemEdit) => {
                    if (
                        prevEditRolloverData === editRolloverData ||
                        (editRolloverData?.componentPath && config.componentPath !== editRolloverData.componentPath)
                    ) {
                        return;
                    }

                    prevEditRolloverData = editRolloverData;
                    config.alerts.forEach((alert) => {
                        const params: TriggerMsg = {
                            componentPath: config.componentPath,
                            variant: alert.variant,
                            message: alert.message,
                            icon: alert.icon,
                        };

                        getChannel()?.trigger('gem-display-component-alert', [params]);
                    });
                };

                this.unsubscribe = gemStore.subscribe((state, prevState) => {
                    if (state.aemEdit !== prevState.aemEdit) {
                        triggerEventByStateChange(state.aemEdit);
                    }
                });

                triggerEventByStateChange();
            }

            disconnectedCallback() {
                this.unsubscribe?.();
            }
        },
    );
}
